import type React from "react";
import { Route, Routes } from "react-router-dom";
import AdminDashboardPage from "@/pages/admin/DashboardPage/DashboardPage";
import UserManagementPage from "@/pages/admin/UserManagementPage/UserManagementPage";
import EventManagementPage from "@/pages/admin/EventManagementPage/EventManagementPage";
import ContentManagementPage from "@/pages/admin/ContentManagementPage/ContentManagementPage";
import ContactManagementPage from "@/pages/admin/ContactManagementPage/ContactManagementPage";
import ContactDetailPage from "@/pages/admin/ContactDetailPage/ContactDetailPage";
import ChannelManagementPage from "@/pages/admin/ChannelManagementPage/ChannelManagementPage";
import AdminLayout from "@/components/admin/Layout/Layout";
import AdminRoute from "@/components/common/AdminRoute/AdminRoute";

const AdminRoutes: React.FC = () => {
	return (
		<Routes>
			<Route element={<AdminRoute />}>
				{/* 管理者権限チェック用のラッパー */}
				<Route element={<AdminLayout />}>
					{/* 管理画面共通レイアウト */}
					<Route path="dashboard" element={<AdminDashboardPage />} />
					<Route path="users" element={<UserManagementPage />} />
					<Route path="events" element={<EventManagementPage />} />
					<Route path="contents" element={<ContentManagementPage />} />
					<Route path="channels" element={<ChannelManagementPage />} />
					<Route path="contacts">
						<Route index element={<ContactManagementPage />} />
						<Route path=":id" element={<ContactDetailPage />} />
					</Route>
				</Route>
			</Route>
		</Routes>
	);
};

export default AdminRoutes;
